import { render } from "./WalletLabels.vue?vue&type=template&id=406a4142"
import script from "./WalletLabels.vue?vue&type=script&lang=js"
export * from "./WalletLabels.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__